import type { PageAllowedFeatures } from '@atlassian/embedded-confluence-common/features';

export const PARENT_PRODUCTS = {
	CONFLUENCE: 'confluence',
	HOME: 'home',
	JIRA: 'jira',
	TEAMS: 'teams',
} as const;

export interface PanelDataMap {
	actions?: {
		onClose: () => void;
		onExpand: () => void;
		onOpenInNewTab?: () => void;
		onPublish?: () => void;
	};
	/**
	 * Forwarded to the embedded Confluence iframe to unlock gated editor surfaces
	 * (e.g. `'publish-modal'` enables the deferred-space-selection modal so that
	 * clicking Publish on a draft prompts the user to choose a space first).
	 */
	allowedFeatures?: PageAllowedFeatures;
	embedUrl?: string;
}
